import type { AutocompleteProps } from "@mui/material";
import type { FC } from "react";
import { AppAutocomplete } from "../../../../../shared/components/AppAutocomplete";
import styles from "./styles.module.css";

export const FolderSelection: FC<
  AutocompleteProps<any, boolean, boolean, boolean>
> = ({ ...props }) => {
  return (
    <div className={styles.card}>
      <AppAutocomplete className={styles.autocomplete} {...props} />
    </div>
  );
};
